// -----------------------------------------------------------------------------
//  Mezzi del Transfer — elenco unico.
//
//  I `value` sono ESATTAMENTE l'enum che sta a database su tre colonne:
//  `booking.vehicle_type`, `booking_request.vehicle_type` e
//  `vehicle_rental.vehicle_type` (COD8, noleggio da fornitore). Un valore fuori
//  elenco non viene ignorato: MySQL rifiuta la scrittura.
//
//  Stanno qui e non in una pagina perché li usano la creazione prenotazione e
//  il dettaglio delle richieste: due copie sono due occasioni di chiamare lo
//  stesso mezzo in due modi diversi.
//
//  `seats` NON esiste a schema. Serve solo ad avvisare quando i passeggeri
//  eccedono la capienza nominale: è un controllo di buon senso, non una regola
//  di dominio, e infatti non blocca il salvataggio.
// -----------------------------------------------------------------------------

//  `rentable` = mezzo che di norma si prende da un FORNITORE esterno, quindi
//  con un costo da registrare (COD8). L'auto del partner e la nostra non si
//  noleggiano: per quelle non ha senso chiedere il fornitore.
//  Non è una regola di database: è il criterio con cui la pagina decide se
//  proporre la registrazione del noleggio.
export const VEHICLES = [
  { value: 'auto_partner', label: 'Auto del partner', seats: 4, rentable: false },
  { value: 'auto_nostra', label: 'Auto Simba', seats: 4, rentable: false },
  { value: 'pulmino_9', label: 'Pulmino 9 posti', seats: 9, rentable: true },
  { value: 'navetta_30', label: 'Navetta 30 posti', seats: 30, rentable: true },
  { value: 'navetta_50', label: 'Navetta 50 posti', seats: 50, rentable: true },
];

export const VEHICLE_LABELS = Object.fromEntries(
  VEHICLES.map((v) => [v.value, v.label]),
);

export const vehicleOf = (value) => VEHICLES.find((v) => v.value === value) || null;

export default { VEHICLES, VEHICLE_LABELS, vehicleOf };
